import { EMPTY_ARR } from '../../constants';
import { formatFieldKeyOut } from '../../fields/FieldUtils';
import type { Option, WorkflowStepFormFieldBlock } from '../../types';
import { applyTransformFuncs, capitalizeFirstLetter } from '../general';

export const formatFormValuesForApi = (
  formValues: Record<string, any>,
  formFieldBlocks: WorkflowStepFormFieldBlock[],
): Record<string, any> =>
  formFieldBlocks.reduce((formattedValues, block) => {
    let value = formValues[block.name];

    // Handle special cases
    if (block.componentType === 'file-upload') {
      // @IMPROVEMENT Hacky
      value = undefined;
    }

    // Ignore fields on submit to prevent unwished keys on document_pairs
    if (block.omitFormValueOnSubmit) {
      value = undefined;
    }

    if (block.componentProps?.isMulti && Array.isArray(value)) {
      // TODO: this doesnt support transformFuncsOut on multiselects
      const options = (block.componentProps?.options ??
        EMPTY_ARR) as Option<string>[];
      const multiValues = options.reduce(
        (acc, option) => ({
          ...acc,
          [`${block.name}${capitalizeFirstLetter(option.value)}`]:
            value.includes(option.value),
        }),
        {} as Record<string, boolean>,
      );
      return {
        ...formattedValues,
        [block.name]: undefined,
        ...multiValues,
      };
    }

    // Apply transform funcs
    if (block.transformFuncsOut && value !== undefined) {
      value = applyTransformFuncs(value, block.transformFuncsOut);
    }

    return {
      ...formattedValues,
      ...(block.name.includes('~')
        ? {
            [block.name]: undefined, // @READ Beware of issue where `relationship~attribute` will stay due to `formValues` being the default value
            [formatFieldKeyOut(block.name)]: value,
          }
        : {
            [block.name]: value,
          }),
    };
  }, formValues);
